import React, { Component } from 'react';
import logo2 from '../assets/logo2.png';
import { Link } from 'react-router-dom';




class RosterChiangmai extends Component {
  state = { walletInfo: {} };
  render() {
    const { address, balance } = this.state.walletInfo;
    return (
      <div className='RosterTuesday2'>
      <div><Link to='/'>Home</Link></div>
      <h3>Member's Names</h3>
      <br />
      <br />

      <div><Link to='/conduct-sombatt'>1. AAT  0489  MR.SOMBAT TAPANYA(Dojocho)(A)</Link></div>
      <br />
      <div><Link to='/conduct-teeraratb'>2. AAT  0974  MR.TEERARAT BORIPANTAKOON(A)</Link></div>
      <br />
      <div><Link to='/conduct-chucheeps'>3. AAT  2350  MR.CHUCHEEP SOONTARANONT(A)</Link></div>
      <br />
      <div><Link to='/conduct-rakchanokc'>4. AAT  2533  MS.RAKCHANOK CHAYUTKUL(A)</Link></div>
      <br />
      <div><Link to='/conduct-narumolt'>5. AAT  3834  MS.NARUMOL THAMMAPRUKSA(A)</Link></div>
      <br />
      <div><Link to='/conduct-ratchadaporns'>6. AAT  1649  MS.RATCHADAPORN SIRIWONG(A)</Link></div>
      <br />
      <div><Link to='/conduct-watcharapols'>7. AAT  3245  MR.WATCHARAPOL SUPAJAKWATTANA(A)</Link></div>
      <br />
      <div><Link to='/conduct-wisutl'>8. AAT  4036  MR.WISUT LEKSOMBOON(A)</Link></div>
      <br />
      <div><Link to='/conduct-pipatphongw'>9. AAT  4191  MR.PIPATPHONG WONGYAI(A)</Link></div>
      <br />
      <div><Link to='/conduct-fuengwichm'>10. AAT  4213  MR.FUENGWICH MANEEKARN(A)</Link></div>
      <br />
      <div><Link to='/conduct-kittisaks'>11. AAT  4416  MAJ.KITTISAK SIRIPARP(A)</Link></div>
      <br />
      <div><Link to='/conduct-siriphornm'>12. AAT  6082  MS.SIRIPHORN MANOKAEW(A)</Link></div>
      <br />
      <div><Link to='/conduct-tarnnamthips'>13. AAT  6253  MS.TARNNAMTHIP SIRIWONG(A)</Link></div>
      <br />
      <div><Link to='/conduct-sukunyak'>14. AAT  7002  MS.SUKUNYA KAEWSANGJAI(A)</Link></div>
      <br />
      <div><Link to='/conduct-janyaporns'>15. AAT  7195  MS.JANYAPORN SAINGAM(A)</Link></div>
      <br />
      <div><Link to='/conduct-xinrongw'>16. AAT  7381  MS.XINRONG WU(A)</Link></div>
      <br />
      <div><Link to='/conduct-phasinl'>17. AAT  6396  MR.PHASIN LEKSOMBUN(A)</Link></div>
      <br />
      <div><Link to='/conduct-rattanas'>18. AAT  7439  MS.RATTANA SUDSOM(A)</Link></div>
      <br />
      <div><Link to='/conduct-phurint'>19. AAT  7691  MR.PHURIN THEERAWECHKUL(A)</Link></div>
      <br />
      <div><Link to='/conduct-matthewp'>20. AAT  7713  MR.MATTHEW PEYTON(A)</Link></div>
      <br />
      <div><Link to='/conduct-anuchaw'>21. AAT  7144  MR.ANUCHA WIBOONWATTANAKIT(A)</Link></div>
      <br />
      <div><Link to='/conduct-lolas'>22. AAT  7678  MS.LOLA SCHOENLAUB(A)</Link></div>
      <br />
      <div><Link to='/conduct-jonathanc'>23. AAT  7872  MR.JONATHAN CAEL(A)</Link></div>
      <br />
      <div><Link to='/conduct-pimpidat'>24. AAT  7906  MS.PIMPIDA THEERAWECHKUL(A)</Link></div>
      <br />
      <div><Link to='/conduct-ketkanoka'>25. AAT  7934  MS.KETKANOK AINSUN(A)</Link></div>
      <br />
      <div><Link to='/conduct-nonthapornk'>26. AAT  7935  MS.NONTHAPORN KETKHAO(A)</Link></div>
      <br />
      <div><Link to='/conduct-pimphisal'>27. AAT  7268  MS.PIMPHISA LEKSOMBUN(A)</Link></div>
      <br />
      <div><Link to='/conduct-pobkhunt'>28. AAT  7857  MR.POBKHUN TRAI-UKOT(A)</Link></div>
      <br />
      <div><Link to='/conduct-purip'>29. AAT  7905  MR.PURI PUENGPIPATTRAKUL(A)</Link></div>
      <br />
      <div><Link to='/conduct-rakhunt'>30. AAT  7882  MS.RAKHUN TRAI-UKOT(A)</Link></div>
      <br />
      <div><Link to='/conduct-pawornwichw'>31. AAT  7967  MASTER PAWORNWICH WONGPENG(A)</Link></div>
      <br />
      <div><Link to='/conduct-amornphitk'>32. AAT  7968  MS.AMORNPHIT KITTIPODJANASIT(A)</Link></div>
      <br />
      <div><Link to='/conduct-punnapatw'>33. AAT  7969  MASTER PUNNAPAT WORACHAYANGKUL(A)</Link></div>
      <br />
      <div><Link to='/conduct-nechayas'>34. AAT  7970  MS.NECHAYA SITTHIKORNWANICH(A)</Link></div>
      <br />
      <div><Link to='/conduct-thantnyim'>35. AAT  7971  MR.THANTNYI MINHTUT(A)</Link></div>
      <br />
      <div><Link to='/conduct-amornphant'>36. AAT  8085  MS.AMORNPHAN THAMMAPRUKSA(A)</Link></div>
      <br />
      <div><Link to='/conduct-piyachutc'>37. AAT  8087  MRS.PIYACHUT CHANTARAMUNGKORN(A)</Link></div>
      <br />
      <div><Link to='/conduct-worapopk'>38. AAT  8091  MR.WORAPOP KERDTONGSOOK(A)</Link></div>
      <br />
      <div><Link to='/conduct-annar'>39. AAT  7958  MS.ANNA RUSSAMEEWONG(A)</Link></div>
      <br />
      <div><Link to='/conduct-darann'>40. AAT  7959  MR.DARAN NANTAPONG(A)</Link></div>
      <br />
      <div><Link to='/conduct-augusts'>41. AAT  8090  MR.AUGUST SELKE(A)</Link></div>
      <br />
      <div><Link to='/conduct-linh'>42. AAT  8063  MR.LIN YAN HTYT(A)</Link></div>
      <br />
      <div><Link to='/conduct-thammachartt'>43. AAT  8086  MR.THAMMACHART THONGWATTANA(A)</Link></div>
      <br />
      <div><Link to='/conduct-andreif'>44. AAT  8088  MR.ANDREI FEDOROV(A)</Link></div>
      <br />
      <div><Link to='/conduct-liudmilam'>45. AAT  8089  MS.LIUDMILA MARYUTINA(A)</Link></div>
      <br />
      <div><Link to='/conduct-porametn'>46. AAT  8092  MR.PORAMET NGOENAINTA(A)</Link></div>
      <br />
      <div><Link to='/conduct-jirananu'>47. AAT  8093  MS.JIRANAN UDOMKITWANIT(A)</Link></div>
      <br />
      <div><Link to='/conduct-phimmadak'>48. AAT  8096  MS.PHIMMADA KHUNKHAMPRA(A)</Link></div>
      <br />
      <div><Link to='/conduct-nadaphatn'>49. AAT  8064  MS.NADAPHAT NGANVONGPANIT(A)</Link></div>
      <br />
      <div><Link to='/conduct-naprachm'>50. AAT  8065  MR.NAPRACH MONUM(A)</Link></div>
      <br />
      <div><Link to='/conduct-nataphatn'>51. AAT  8066  MR.NATAPHAT NGANVONGPANIT(A)</Link></div>
      <br />
      <div><Link to='/conduct-pichamonc'>52. AAT  8094  MS.PICHAMON CHAIWONG(A)</Link></div>
      <br />
      <div><Link to='/conduct-parinb'>53. AAT  8095  MR.PARIN BOONYADETWONG(A)</Link></div>
      <br />
      <div><Link to='/conduct-yihaow'>54. AAT  8098  MR.YIHAO WANG(A)</Link></div>
      <br />
      <div><Link to='/conduct-aniwatl'>55. AAT  8102  MR.ANIWAT LEKPASOM(A)</Link></div>
      <br />

        <br />
        <div>
          Thailand's Aikido Association Class Attending System...
        </div>
          <br />
          <br />
        <div>Powered by</div><img className='logo2' src={logo2}></img><div>New Wave Consulting Group</div>
      </div>
    );
  }
}
export default RosterChiangmai;
